import { Divider, Stack, Typography } from '@mui/material';
import { formatDate } from '../../../../../../../util/date';
import { Dayjs } from 'dayjs';

interface TimeDisplayProps {
    dueDate: string | Dayjs | null | undefined;
    showTime: boolean;
}

export const TimeDisplay: React.FC<TimeDisplayProps> = ({ dueDate, showTime }) => {
    if (!dueDate || !showTime) return null;

    return (
        <>
            <Divider flexItem />
            <Stack
                direction="row"
                p={0.5}
                justifyContent="flex-end"
                sx={{
                    opacity: 0.8,
                    fontSize: '0.75rem',
                    fontWeight: 'medium',
                    display: 'flex',
                    gap: 0.5,
                    alignItems: 'center',
                    minWidth: 'fit-content',
                }}
            >
                <Typography
                    component="span"
                    variant="caption"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }}
                >
                    {formatDate(dueDate, false, { format: 'hh:mm A' })}
                </Typography>
            </Stack>
        </>
    );
}; 